<template>
  <div class="wrapper">
    <AdminBreadCrumb :list="[parentPage]" title="代理店マージン承認管理" />
    <v-container ma-0 fluid>
      <SearchBar :filter="filter" :search-result="searchResult">
        <v-radio-group v-model="bulkEditMode" class="pt-4" row>
          <v-radio :value="false" label="個別承認" />
          <v-radio :value="true" label="一括承認" />
        </v-radio-group>
      </SearchBar>
      <div>
        <AgencyMarginRequestTable
          :items="searchResult.items"
          :approvable-items="approvableItems"
          :selected-items="selectedItems"
          :loading="loading"
          :input-sort-options="sortOptions"
          :bulk-edit-mode="bulkEditMode"
        />
      </div>
      <BottomActionsBar :visible="bulkEditMode && selectedItems.length > 0">
        <v-spacer />
        <v-btn color="primary" @click="confirmBulkUpdate"
          >選択した申請を一括承認</v-btn
        >
      </BottomActionsBar>
    </v-container>
  </div>
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import AdminBreadCrumb from '@/components/Shared/BreadCrumb/AdminBreadCrumb'
import SearchBar from '@/components/Admin/Request/AdminAgencyMarginRequest/SearchBar'
import AgencyMarginRequestTable from '@/components/Admin/Request/AdminAgencyMarginRequest/AgencyMarginRequestTable'
import {
  actions,
  getters,
} from '@/vuex/modules/admin/request/agencyMargin/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'
import BottomActionsBar from '@/components/Shared/ToolBar/BottomActionsBar'

export default {
  name: 'AdminAgencyMarginRequest',
  components: {
    AdminBreadCrumb,
    SearchBar,
    AgencyMarginRequestTable,
    BottomActionsBar,
  },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  data() {
    return {
      bulkEditMode: false,
    }
  },
  computed: {
    searchResult() {
      return this.$store.getters[getters.searchResult]
    },
    loading() {
      return this.$store.getters[getters.loading]
    },
    sortOptions() {
      return this.$store.getters[getters.sortOptions]
    },
    filter() {
      return this.$store.getters[getters.filter]
    },
    budgetRequestList() {
      return this.$store.getters[getters.searchResult].items
    },
    selectedItems() {
      return this.$store.getters[getters.selectedItems]
    },
    approvableItems() {
      return this.$store.getters[getters.approvableItems]
    },
    parentPage() {
      return { path: null, title: '承認管理' }
    },
  },
  watch: {
    sortOptions: {
      handler() {
        this.search()
      },
      deep: true,
    },
  },
  created() {
    this.search()
  },
  destroyed() {
    this.$store.dispatch(actions.INIT)
  },
  methods: {
    async search() {
      await this.$store.dispatch(actions.SEARCH)
    },
    async confirmBulkUpdate() {
      const count = this.selectedItems.length
      const result = await this.$confirm(
        `${count}件の申請を一括で承認しますがよろしいですか？`,
      )
      if (result) {
        try {
          await this.$store.dispatch(actions.BULK_APPROVE)
          this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
            type: snackbarType.SUCCESS,
            message: '承認しました',
          })
          this.$store.dispatch(actions.SEARCH)
        } catch (e) {
          throw e
        }
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  padding-bottom: 100px;
}
</style>
